import { useMutation, useQueryClient } from 'react-query';

import { userApi } from 'src/Services/API';

export const useSetFavoriteAsset = () => {
  const queryClient = useQueryClient();

  return useMutation(
    async (assetId: string | null) => {
      const response = await userApi.userControllerSetFavoriteAsset({
        assetId,
      });
      return response.data;
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries('fetch-user');
      },
    }
  );
};
